import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "../../lib/data";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float"
    aria-label="Chat WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, type: "spring", stiffness: 200 }}
    className="fixed bottom-5 right-5 z-[60] group"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
    <span className="relative flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold pl-4 pr-5 py-3.5 shadow-2xl shadow-[#25D366]/40 transition-colors">
      <MessageCircle className="h-6 w-6" />
      <span className="hidden sm:inline text-sm">Chat WhatsApp</span>
    </span>
  </motion.a>
);
